import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../../../environments/environment";

import * as _ from "lodash";
import { MCause } from "src/app/shared/models/cause.model";
import { MCauseArray } from "src/app/shared/models/cause-array.model";
import { MCauseEvidence } from "src/app/shared/models/cause-evidence.model";
import { saveAs } from "file-saver";

@Component({
  selector: "app-other-method",
  templateUrl: "./other-method.component.html",
  styleUrls: ["./other-method.component.scss"],
})
export class OtherMethodComponent implements OnInit {
  @Input() data: MCause[];
  @Input() method: any;
  @Input() readOnly: boolean = false;

  @Output() removeMethod = new EventEmitter();
  @Output() updateMethod = new EventEmitter();
  @Output() public emitCauses = new EventEmitter();

  public causes: MCause[] = [];
  public modalTitle: string = "";
  public envUrl = environment.apiUrl;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // console.log(this.data)
    // console.log(this.method);
    if (this.data) {
      if (this.data.length > 0) {
        this.causes = this.data;
        this.emitData();
      } else {
        this.addCause();
      }
    } else {
      this.addCause();
    }
    console.log("causas paso 3", this.causes);
  }

  addCause() {
    this.causes.push(
      new MCause({
        regular: {
          descripcion: "",
          id: null,
          metodo_analisis: { id: 5, nombre: "" },
        },
      })
    );
    this.emitData();
  }

  public deleteCause(modal, index: number) {
    this.modalTitle = "treatment.methods.because.modalTitle";
    this.modalService.open(modal, { centered: true }).result.then(
      () => {
        this.causes.splice(index, 1);
      },
      () => {}
    );
  }

  public deleteCauseEvidence(modal, index: number, position: number) {
    if (!this.readOnly) {
      // console.log(index, position)
      this.modalTitle = "treatment.methods.deleteEvidence";
      this.modalService.open(modal, { centered: true }).result.then(
        () => {
          this.causes[index].evidence.splice(position, 1);
        },
        () => {}
      );
    }
  }

  remove() {
    this.removeMethod.emit(this.method);
    this.updateMethod.emit(false);
  }

  public onFileChange(event, index: number) {
    // console.log(event)
    // console.log(index)
    for (let i = 0; i < event.target.files.length; i++) {
      let push = true;
      for (let j = 0; j < this.causes[index].evidence.length; j++) {
        if (
          event.target.files[i].name === this.causes[index].evidence[j].name
        ) {
          push = false;
        }
      }
      if (push) {
        const reader: any = new FileReader();
        reader.readAsDataURL(event.target.files[i]);
        reader.onload = (res) => {
          // console.log(res)
          this.causes[index].evidence.push(
            new MCauseEvidence(
              {
                id: null,
                descripcion: event.target.files[i].name,
              },
              res.target.result
            )
          );
        };
        // this.causes[index].evidence.push(event.target.files[i])
      }
    }
    // console.log(this.causes)
    this.emitData();
    // const reader: any = new FileReader();
    // reader.readAsDataURL(file);
    // reader.onload = () => {
    //     // if (this.textFile[this.selectFile.id] !== undefined) {
    //     //     this.textFile[this.selectFile.id].push({
    //     //         id: null,
    //     //         name: file.name,
    //     //         base64: reader.result.split(',')[1]
    //     //     });
    //     // } else {
    //     //     this.textFile[this.selectFile.id] = [{
    //     //         id: null,
    //     //         name: file.name,
    //     //         base64: reader.result.split(',')[1]
    //     //     }];
    //     // }
  }

  public emitData() {
    let definitiveCauses: MCause[] = [];
    let allCauses: MCauseArray[] = [];
    for (let i = 0; i < this.causes.length; i++) {
      if (
        this.causes[i].description !== "" &&
        this.causes[i].method.name !== ""
      ) {
        definitiveCauses.push(this.causes[i]);
        allCauses.push(new MCauseArray([]));
        this.causes[i].selected = true;
        this.causes[i].definitiveSelected = this.causes[i].definitiveId
          ? this.causes[i].definitiveSelected
          : true;
        allCauses[allCauses.length - 1].causes.push(this.causes[i]);
      }
    }
    this.emitCauses.emit({
      data: {
        definitive: definitiveCauses,
        causes: allCauses,
      },
      id: 5,
    });
  }
  openFile(file) {
    console.log(file);
    // let data = this.globals.apiUrl + file.fileUrl;
    // saveAs(data, file.name);

    const blob = this.b64ToBlob(file.base64);
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl);
  }
  b64ToBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
